var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('menuLateral'),_c('navbar'),_c('div',{staticClass:"position-absolute app-wrapper px-3"},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }